<template>
  <div class="members-package-list">
    <div
      class="members-package"
      v-for="(item, index) in membersPackageList"
      :key="index"
    >
      <div class="name">{{ item.name }}</div>
      <div class="service-items">
        <van-cell-group>
          <van-cell
            :title="items.itemName"
            :value="items.quantity + items.unit"
            v-for="(items, index) in item.serviceItems"
            :key="index"
          />
        </van-cell-group>
      </div>
      <div class="operation">
        <div class="tips">默认有效期{{ item.termOfValidity }}天</div>
        <div class="btn">
          <span
            class="iconfont iconshanchu1"
            @click="handleDelete(item.id)"
          ></span>
          <span class="iconfont iconbianji" @click="handleEdit(item.id)"></span>
        </div>
      </div>
    </div>
    <div class="add">
      <van-button type="primary" to="/combo/membersPackage">
        新建套餐
      </van-button>
    </div>
  </div>
</template>
<script>
import "@/icons/iconfont.css";
import { membersPackageList, deleteMembersPackage } from "@/api/combo";
import { Dialog } from "vant";
export default {
  data() {
    return {
      membersPackageList: []
    };
  },
  mounted() {
    this.handleMembersPackageList();
  },
  methods: {
    // 套餐列表
    handleMembersPackageList() {
      membersPackageList().then(res => {
        // console.log("套餐列表 :>> ", res);
        this.membersPackageList = res;
      });
    },
    // 删除套餐
    handleDelete(id) {
      Dialog.confirm({
        title: "温馨提示",
        message: "确定删除该套餐吗?"
      }).then(() => {
        deleteMembersPackage(id).then(res => {
          if (res.code === 0) {
            this.$toast("删除成功");
            this.handleMembersPackageList();
          }
        });
      });
    },
    // 编辑套餐
    handleEdit(id) {
      this.$router.push({
        name: "EditMembersPackage",
        query: {
          id: id
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.members-package-list {
  padding: 20px 10px;

  .members-package {
    padding: 20px;
    margin-bottom: 20px;
    background-color: #f4f4f4;

    .name {
      text-align: left;
      margin-bottom: 10px;
    }

    .service-items {
      margin-bottom: 10px;
    }

    .operation {
      display: flex;
      align-items: center;

      .tips {
        flex: 1;
        text-align: left;
      }

      .btn {
        flex: 1;
        text-align: right;

        .iconfont {
          font-size: 20px;
        }

        .iconshanchu1 {
          margin-right: 30px;
          color: red;
        }

        .iconbianji {
          color: blue;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.members-package-list {
  .service-items {
    .van-cell {
      padding: 10px 0;
      background-color: #f4f4f4;

      .van-cell__title {
        text-align: left;
      }
    }
  }
}
</style>
